import _createClass from '@babel/runtime/helpers/createClass';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import ExtendableError from '../error/ExtendableError.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var HttpError = /*#__PURE__*/function (_ExtendableError) {
  _inherits(HttpError, _ExtendableError);
  var _super = _createSuper(HttpError);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function HttpError(message, status, response) {
    var _this;
    _classCallCheck(this, HttpError);
    _this = _super.call(this, message);
    _this.status = status;
    _this.response = response;
    _this.name = "HttpError";
    return _this;
  }
  return _createClass(HttpError);
}(ExtendableError);
var HttpError$1 = HttpError;

export { HttpError$1 as default };
//# sourceMappingURL=httpError.js.map
